import React, { useMemo, type FC } from 'react'

import { useIntl } from 'react-intl'

import { Select } from 'mailup-web-components'

import { changeCriterionCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'
import { criterionFilterState } from 'Pages/RecipientsList/recoil/state/filters'
import { useRecoilCallback, useRecoilValue } from 'recoil'

interface InputFilterModeProps {
  index: number
}

const InputFilterMode: FC<InputFilterModeProps> = ({ index }) => {
  const intl = useIntl()

  const { mode } = useRecoilValue(criterionFilterState(index))

  const changeCriterion = useRecoilCallback(changeCriterionCallback, [])

  const options = useMemo(() => {
    return [
      {
        value: 'And',
        label: intl.formatMessage({ id: 'Load.RecipientsList.FilterModeAnd' }),
      },
      {
        value: 'Or',
        label: intl.formatMessage({
          id: 'Load.RecipientsList.FilterModeOr',
        }),
      },
    ]
  }, [intl])

  const handleChange = (v: string): void => {
    void changeCriterion('mode', v, index)
  }

  return (
    <Select
      value={mode}
      options={options}
      onChange={handleChange}
      data-mu-test="select-filter-mode"
    />
  )
}

export default InputFilterMode
